import queryString from 'query-string';

export const getUrlParams = () => queryString.parse(window.location.search);

export const setUrlParams = (type, id) =>
  window.history.pushState('', '', `?type=${type}&id=${id}`);
